import React from 'react';
const SectionHeader = ({ title, PageLink }) => { 
    return (
        <>
            <header className="header">
                <div className="header__container">
                    <div className="header__content container" data-aos="fade-right" data-aos-duration="1000" data-aos-easing="linear">
                        <h1>{title}</h1>
                    </div>
                </div>
            </header>
        </>
    )
}

export default SectionHeader
